import Vue from 'vue'
import store from 'store'
import $ from 'jquery'
import on from 'dom-event'
import select from 'dom-select'
import targetToggle from 'modules/global/target-toggle/target-toggle'
import { mapState, mapActions } from 'vuex'

export default el => new Vue({
  el,
  store,
  data () {
    return {
    }
  },
  mounted () {
    const navDropdowns = document.querySelectorAll('.nav__dropdown')

    navDropdowns.forEach((nav, index) => {
      const navHeight = nav.scrollHeight
      const windowHeight = window.innerHeight

      if (navHeight > windowHeight) {
        navDropdowns[index].classList.add('overflowing')
      } else {
        navDropdowns[index].classList.add('fits')
      }
    })

    $(document).on('click', '.js-open-dropdown', function (e) {
      e.preventDefault()

      // Scroll the window to the top before opening the third-level drawer
      window.scrollTo(0, 0)

      const $targetElement = $(this).parent().parent()
      $targetElement.addClass('active-sub-menu')
      $targetElement.parent().addClass('overflow-hidden')

      // Scroll nav-mobile to top before opening third-level drawer
      const navMobile = document.getElementById('nav-mobile')
      if (navMobile) {
        navMobile.scrollTop = 0
      }

      // Scroll the second-level drawer to the top before opening the third-level drawer
      const secondLevelDrawer = document.querySelector('.nav__dropdown[data-level="2"].is-visible')
      if (secondLevelDrawer) {
        secondLevelDrawer.scrollTop = 0
        const _ = secondLevelDrawer.offsetHeight
      }

      // Use requestAnimationFrame to wait for the next paint
      requestAnimationFrame(() => {
        $(this).closest('.nav__item').find('.nav__dropdown:first').addClass('is-visible')
        $('body').addClass('active-sub-menu-t')
      })

      const $submenu = $(this).parent('.nav__item').find('.nav__dropdown ul.nav_sub-top')
      const $submenuHeight = $submenu.outerHeight()

      const $headerH = $('.header').outerHeight()
      const $navBackTitleH = $('.nav__back--title').outerHeight()

      // console.log('Height of header element :', $headerH)
      // console.log('Height of nav-back-title element :', $navBackTitleH)
      // console.log('Height of header back:', $headerH + $navBackTitleH)

      console.log('Height of active-sub-menu element :', $submenuHeight)
      // Set CSS variable on the element
      // $submenu[0].style.setProperty('--submenu-height', $submenuHeight + 'px')

      // Show dropdown
      $(this).closest('.nav__item').find('.nav__dropdown:first').addClass('is-visible')
      $('body').addClass('active-sub-menu-t')

      // Apply style to img via CSS variable usage
      $submenu.find('img').each(function () {
        // this.style.height = 'min(calc(100vh - (var(--submenu-height, 0px) + 190px)), 300px)'
      })
    })

    $(document).on('click', '.nav__data-level-2.js-close-dropdown', function (e) {
      e.preventDefault()
      $('body').removeClass('active-sub-menu-t')
    })

    $(document).on('click', '.nav__data-level-3.js-close-dropdown', function (e) {
      e.preventDefault()
      $('.nav__dropdown.nav__data-level-2 ').removeClass('overflow-hidden')
    })

    $(document).on('click', '.js-close-dropdown', function (e) {
      e.preventDefault()
      $('ul').removeClass('active-sub-menu')
      $(this).closest('.is-visible').removeClass('is-visible')
    })

    select.all('.js-hide-dropdown', el).map(element => {
      on(element, 'click', event => {
        console.log('close dropdown')
        element.closest('.is-visible').classList.remove('is-visible')
        element.closest('.nav-mobile').classList.remove('is-visible')
        element.closest('body').classList.remove('nav-mobile-active')
        element.closest('body').classList.remove('no-scroll')
        element.closest('body').style.removeProperty('overflow')
        $('body').removeClass('active-sub-menu-t')
      })
    })

    targetToggle(el)
  },
  methods: {
    ...mapActions('cart', [
      'toggleCart',
      'closeCart'
    ]),
    ...mapActions('global', [
      'toggleSearch'
    ])
  }
})
